import { useSeo } from "../lib/seo";
import { Hero } from "../components/home/Hero";
import { Intro } from "../components/home/Intro";
import { ServicesIndex } from "../components/home/ServicesIndex";
import { SelectedWork } from "../components/home/SelectedWork";
import { Method } from "../components/home/Method";
import { Marquee } from "../components/Marquee";
import { ContactCta } from "../components/ContactCta";

export default function Home() {
  useSeo(
    "Comunicazione digitale e social media in Lombardia | B Digital Studio",
    "Studio di comunicazione digitale tra Como, Monza e Brianza, Varese e Lecco: social media, produzione foto e video, Meta Ads e strategie di lancio per attività."
  );
  return (
    <>
      <Hero />
      <Marquee />
      <Intro />
      <ServicesIndex />
      <SelectedWork />
      <Method />
      <ContactCta n="05" />
    </>
  );
}
